import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop.jsx';

const PageRoutes = () => {

	const Home = React.lazy(() => import('../pages/Home/Home.jsx'));
	const Contact = React.lazy(() => import ('../pages/Contact/Contact.jsx'))
	const Construction = React.lazy(() => import ('../pages/Construction/ConstructionPage.jsx'))
	const Sound = React.lazy(() => import ('../pages/Sound/SoundForHirePage.jsx'))
	const IT = React.lazy(() => import ('../pages/Software/SoftwarePage.jsx'))

  return (
		<>
			<ScrollToTop />
			<Suspense fallback={<div></div>}>
				<Routes>
					<Route path='/' element={<Home/>}></Route>
					<Route path='/contact-us' element={<Contact/>}></Route>
					<Route path='/construction' element={<Construction/>}></Route>
					<Route path='/sound-hire' element={<Sound/>}></Route>
					<Route path='/software-development' element={<IT/>}></Route>
				</Routes>
			</Suspense>
		</>
  )
}

export default PageRoutes